import t, { hasTranslation, type TranslationKey } from "@ext/localization/locale/translate";

export const getPropertyValueLabel = (propertyName: string, value: string): string => {
	const translationKey: TranslationKey = `properties.system.${propertyName}.values.${value}`;
	return hasTranslation(translationKey) ? t(translationKey) : value;
};
